import React from 'react';
import { Chip, Tooltip } from '@material-ui/core';

const betaLabelStyles = {
  height: '16px',
  fontSize: '8px',
  fontWeight: 'bold',
};

const BetaLabel = ({ classAttr }) => {
  const message =
    'This Beta Feature is recently launched, and we are excited to get your feedback about it. Please click your profile image in the top-right corner of the screen to submit feedback, or reach out to your Zippity contact.';

  return (
    <Tooltip title={message}>
      <span className={classAttr}>
        <Chip label="BETA" size="small" style={betaLabelStyles} />
      </span>
    </Tooltip>
  );
};

export default BetaLabel;
